import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {WidgetCheckboxV0NodeDto} from "../models/widget-checkbox-v0-node.dto";


@Component({
  selector: 'pt-widget-checkbox-v0-tree-dialog',
  templateUrl: 'widget-checkbox-v0-tree-dialog.component.html',
  styleUrls: [`widget-checkbox-v0-tree-dialog.component.scss`]
})
export class WidgetCheckboxV0TreeDialogComponent {
  @Input() showShowOnlySelectedFilter = false;
  @Input() title?: string;

  disabled = false;
  loading = false;
  checkbox: WidgetCheckboxV0NodeDto[];
  selectedNodeIds: string[] = [];

  constructor(public activeModal: NgbActiveModal) {

  }

  loadCheckbox(checkbox: WidgetCheckboxV0NodeDto[]) {
    this.checkbox = checkbox;
    this.selectedNodeIds = [];
  }

  changeSelectedRowId(selectedNodeIds: string[]) {
    this.selectedNodeIds = selectedNodeIds;
  }

  apply() {
    this.activeModal.close(this.selectedNodeIds);
  }

  close() {
    this.activeModal.close(undefined);
  }
}
